import { connect } from 'react-redux';
import SlideLayout from '../components/SlideLayout.js';

const mapStateToProps = (state, props) => {
  return state.slides.byId[props.id] || {};
};

export default connect(
  mapStateToProps,
  null,
  null,
  { forwardRef: true }
)(SlideLayout);
